<template>
  <div :style="boxWrapStyleObj" class="nj-header-title" style="position: relative;">
    <div class="header-title-area" ref="statisTitle">
      <div class="area-title">
        <img src="../../../assets/images/nanjindataboard/right-row.png" />
        <p class="title-text">学科应用分析</p>
      </div>
      <img
        src="../../../assets/images/nanjindataboard/bottom-bg.png"
        style="float: left"
      />
    </div>
    <div class="content" :style="contentStyleObj">
      <div class="district-subject-wrap">
        <div class="left-container" style="width: 57%">
          <div class="left-container-wrap">
            <div class="subject-count-title" :style="rowStyleObj">
              <span class="subject-title" style="width: 30%">学科</span>
              <span class="count-title" style="width: 70%">使用次数</span>
            </div>
            <template v-for="(item, index) in data" v-if="data.length > 0">
              <div
                class="subject-count-name"
                v-if="index % 2 === 0"
                :style="rowStyleObj"
                style="background-color: #102243"
              >
                <span class="subject-name" style="width: 30%">{{
                  item.subject_name
                }}</span>
                <span
                  class="submit-count"
                  style="width: 70%"
                  :title="item.count + '次'"
                  >{{ item.count }}次</span
                >
              </div>
              <div class="subject-count-name" v-else :style="rowStyleObj">
                <span class="subject-name" style="width: 30%">{{
                  item.subject_name
                }}</span>
                <span
                  class="submit-count"
                  style="width: 70%"
                  :title="item.count + '次'"
                  >{{ item.count }}次</span
                >
              </div>
            </template>
          </div>
          <!--</div>-->
        </div>
        <div class="left-container" style="width: 43%">
          <!--图例-->
          <div class="echart-legend">
            <div class="legend-item" @click="selectLegend('小学')">
              <p
                class="legend-item-color"
                :style="
                  legendIndex == '小学'
                    ? { background: '#24C4DC' }
                    : { background: '#A2A2A2' }
                "
              ></p>
              <p class="legend-item-text">小学</p>
            </div>
            <div class="legend-item" @click="selectLegend('初中')">
              <p
                class="legend-item-color"
                :style="
                  legendIndex == '初中'
                    ? { background: '#ED8167' }
                    : { background: '#A2A2A2' }
                "
              ></p>
              <p class="legend-item-text">初中</p>
            </div>
            <div class="legend-item" @click="selectLegend('高中')">
              <p
                class="legend-item-color"
                :style="
                  legendIndex == '高中'
                    ? { background: '#FAE17C' }
                    : { background: '#A2A2A2' }
                "
              ></p>
              <p class="legend-item-text">高中</p>
            </div>
          </div>
          <div style="width: 100%; height: 100%" id="data_homework"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "subject-applica-analy",
  props: {
    screenHeight: Number,
    titleHeight: Number,
  },
  data() {
    return {
      legendIndex: "初中",
      color:[
                    { offset: 0, color: "#00FEFF" },
                    { offset: 0.9, color: "#24C4DC" },
                    { offset: 1, color: "#24C4DC" },
                  ],
      data: [
        {
          subject_name: "数学",
          count: "1036154",
        },
        {
          subject_name: "语文",
          count: "924756",
        },
        {
          subject_name: "英语",
          count: "669914",
        },
        {
          subject_name: "物理",
          count: "306726",
        },
        {
          subject_name: "生物",
          count: "239582",
        },
        {
          subject_name: "历史",
          count: "225848",
        },
      ],
      screenWidth: 0, //屏幕宽度
      boxWrapStyleObj: {
        height: "",
      },
      contentStyleObj: {
        height: "",
      },
      rowStyleObj: {
        height: "",
        lineHeight: "",
      },
    };
  },
  watch: {
    screenHeight: "initBoxHeight",
    titleHeight: "initBoxHeight",
  },
  methods: {
    /**
     * 图例切换
     */
    selectLegend(item) {
      let seriesDataArr = [];
      let indicator = [];
      this.legendIndex = item;
      let color='';
      if (item == "小学") {
        seriesDataArr = [
          {
            value: [
              3755486,
              2430918,
              1919708,
              697382,
              457800,
              428806,
              366240,
              328090,
              24416,
            ],
            name: "小学",
            areaStyle: {
              normal: {
                opacity: 0.78,
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#00FEFF" },
                  { offset: 0.9, color: "#24C4DC" },
                  { offset: 1, color: "#24C4DC" },
                ]),
              },
            },
          },
        ];
        indicator = [
          { name: "语文" },
          { name: "数学" },
          { name: "英语" },
          { name: "体育" },
          { name: "音乐" },
          { name: "美术" },
          { name: "信息技术" },
          { name: "科学" },
          { name: "道德与法治" },
        ];
        this.color=[ { offset: 0, color: "#00FEFF" },
                  { offset: 0.9, color: "#24C4DC" },
                  { offset: 1, color: "#24C4DC" }];
        this.data = [
          {
            subject_name: "语文",
            count: "3755486",
          },
          {
            subject_name: "数学",
            count: "2430918",
          },
          {
            subject_name: "英语",
            count: "1919708",
          },
          {
            subject_name: "体育",
            count: "697382",
          },
          {
            subject_name: "音乐",
            count: "457800",
          },
          {
            subject_name: "美术",
            count: "428806",
          },
        ];
          color="#2783CD";
      } else if (item == "初中") {
        seriesDataArr = [
          {
            value: [
              1036154,
              924756,
              669914,
              306726,
              239582,
              225848,
              210588,
              169386,
              28994,
            ],
            name: "初中",
            areaStyle: {
              normal: {
                opacity: 0.78,
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#ED8167" },
                  { offset: 0.9, color: "#ED8167" },
                  { offset: 1, color: "#ED8167" },
                ]),
              },
            },
          },
        ];
        indicator = [
          { name: "数学" },
          { name: "语文" },
          { name: "英语" },
          { name: "物理" },
          { name: "生物" },
          { name: "历史" },
          { name: "体育" },
          { name: "化学" },
          { name: "政治" },
        ];
        this.color=[ { offset: 0, color: "#ED8167" },
                  { offset: 0.9, color: "#ED8167" },
                  { offset: 1, color: "#ED8167" }];
        this.data = [
          {
            subject_name: "数学",
            count: "1036154",
          },
          {
            subject_name: "语文",
            count: "924756",
          },
          {
            subject_name: "英语",
            count: "669914",
          },
          {
            subject_name: "物理",
            count: "306726",
          },
          {
            subject_name: "生物",
            count: "239582",
          },
          {
            subject_name: "历史",
            count: "225848",
          },
        ];
          color="#FFB888";
      } else if (item == "高中") {
        seriesDataArr = [
          {
            value: [
              346402,
              267050,
              250264,
              187698,
              120554,
              111398,
              102242,
              102242,
              93086
            ],
            name: "高中",
            areaStyle: {
              normal: {
                opacity: 0.78,
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#FAE17C" },
                  { offset: 0.9, color: "#FAE17C" },
                  { offset: 1, color: "#FAE17C" },
                ]),
              },
            },
          },
        ];
        indicator = [
          { name: "数学" },
          { name: "语文" },
          { name: "英语" },
          { name: "物理" },
          { name: "化学" },
          { name: "地理" },
          { name: "历史" },
          { name: "生物" },
          { name: "政治" },
        ];
        this.color=[ { offset: 0, color: "#FAE17C" },
                  { offset: 0.9, color: "#FAE17C" },
                  { offset: 1, color: "#FAE17C" }];
        this.data = [
          {
            subject_name: "数学",
            count: "346402",
          },
          {
            subject_name: "语文",
            count: "267050",
          },
          {
            subject_name: "英语",
            count: "250264",
          },
          {
            subject_name: "物理",
            count: "187698",
          },
          {
            subject_name: "化学",
            count: "120554",
          },
          {
            subject_name: "地理",
            count: "111398",
          },
        ];
        color="#FAFA6B";
      }
      this.initHomework(seriesDataArr, indicator,color);
    },
    /**
     * 初始化box高度
     */
    initBoxHeight() {
      let winHeight = window.innerHeight;
      if (winHeight < 900) {
        winHeight = 938;
      }

      let boxWrapHeight = (winHeight - 128 - 10 - 30 - 20) / 3;
      let contentHeight =
        boxWrapHeight - this.$refs.statisTitle.offsetHeight - 20;
      this.boxWrapStyleObj.height = boxWrapHeight + "px";
      this.contentStyleObj.height = contentHeight + "px";
      let rowHight = contentHeight / 7;
      this.rowStyleObj.height = rowHight + "px";
      this.rowStyleObj.lineHeight = rowHight + "px";
    },
    /**
     * 加载饼状图
     */
    initHomework(data, indicator,color) {
      let dataSourcePie = this.$echarts.init(
        document.getElementById("data_homework")
      );
      let radiusVal = 60;
      let fontSize = 12;
      if (this.screenWidth <= 1280) {
        radiusVal = 30;
      }
      const option = {
        // legend: {
        //     data: ['小学','初中', '高中']
        // },
        tooltip: {},
        radar: {
          name: {
            textStyle: {
              formatter: "{value}",
              color: "#708ACC",
              fontSize: fontSize,
            },
          },
          center: ["55%", "50%"],
          radius: radiusVal,
          shape: "circle",
          splitArea: {
            areaStyle: {
              color: color,
              opacity: 0.2,
              shadowColor: "#D2F7F9",
              shadowBlur: 10,
            },
          },
          splitLine: {
            lineStyle: {
              width: 1,
              color: color,
              opacity: 0.45,
            },
          },
          axisLine: {
            lineStyle: {
              color: "#708ACC",
            },
          },
          indicator: indicator,
        },
        series: [
          {
            name: "",
            type: "radar",
            symbol: "none", //去掉边拐点
            itemStyle: {
              normal: {
                lineStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, this.color),
                },
              },
            },
            data: data,
          },
        ],
      };
      dataSourcePie.setOption(option);

      window.addEventListener("resize", function () {
        dataSourcePie.resize();
      });
    },
  },
  mounted() {
    //获取屏幕宽度
    this.screenWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    this.initBoxHeight();
    this.$nextTick(() => {
      this.selectLegend("初中");
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";

.header-title-area {
  margin-bottom: 30px;
  .area-title {
    display: flex;
    align-items: center;
    img {
      width: 13px;
      height: 20px;
      margin-right: 5px;
    }
    .title-text {
      font-size: 18px;
      font-weight: bold;
      color: #00bbff;
    }
  }
}
</style>
